import App from './components/app.jsx';
import React from 'react';
import ReactDOM from 'react-dom/client';
import initSentry from './sentry.js';
import {BrowserRouter} from 'react-router-dom';

// Setup Sentry
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename={import.meta.env.BASE_URL}>
    <App />
  </BrowserRouter>,
);
